import isFireTvUserAgent from 'isFireTvUserAgent';

// ManifestState's statuses (useWallboardManifest), not imported from it as
// that imports this
type ShownStatus =
  | 'loading'
  | 'preparing'
  | 'removed'
  | 'unavailable'
  | 'ready';

/**
 * What the player is showing, as a query string for its manifest poll:
 * getWallboardManifest records it as the TV's heartbeat (the TV can't write
 * to Firestore itself). The standalone TV player uses this on Chrome 53, so
 * no object spread or newer built-ins.
 */
const buildHeartbeatQuery = ({
  player,
  status,
  slideId,
}: {
  player: 'app' | 'tv';
  status: ShownStatus;
  slideId: string | undefined;
}): string => {
  const params: [string, string | undefined][] = [
    ['player', player],
    ['status', status],
    ['slideId', slideId],
    ['appVersion', process.env.REACT_APP_VERSION || undefined],
    ['fireTv', isFireTvUserAgent() ? '1' : undefined],
  ];
  const pairs = params
    .filter((param): param is [string, string] => !!param[1])
    .map(
      ([name, value]) =>
        `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
    );
  return `?${pairs.join('&')}`;
};

export default buildHeartbeatQuery;
